const routes = [
  {
    path: "/manutencao-local-lotacao",
    name: "manutencao-local-lotacao",
    meta: {
      allowedPermissions: ["local_lotacao_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoLocalLotacao/ManutencaoLocalLotacaoHome.vue"),
  },
  {
    path: "/manutencao-local-lotacao/novo",
    name: "manutencao-local-lotacao-novo",
    meta: {
      allowedPermissions: ["local_lotacao_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoLocalLotacao/ManutencaoLocalLotacaoCad.vue"),
  },
  {
    path: "/manutencao-local-lotacao/editar/:id",
    name: "manutencao-local-lotacao-editar",
    meta: {
      allowedPermissions: ["local_lotacao_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoLocalLotacao/ManutencaoLocalLotacaoEdit.vue"),
  },
];

export default routes;
